export default {
    computed: {
        isTouch: function() {
            return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/auth/touchMixin.js